// Footer.js
import { useEffect, useState } from "react";
import "./footer.css";
import { Link } from "react-router-dom";

import logoDark from "./dentoshine.jpg";   // black theme logo
import logoLight from "./dlogo.png"; // white theme logo

export default function Footer() {
  const [theme, setTheme] = useState("dark");

  // Detect theme whenever it changes globally
  useEffect(() => {
    const current = document.documentElement.getAttribute("data-theme") || "dark";
    setTheme(current);

    // Listen for theme changes triggered elsewhere
    const observer = new MutationObserver(() => {
      const newTheme = document.documentElement.getAttribute("data-theme");
      setTheme(newTheme);
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"]
    });

    return () => observer.disconnect();
  }, []);

  // Pick correct logo
  const footerLogo = theme === "dark" ? logoDark : logoLight;

  return (
    <footer className="footer">
      <div className="footer-inner">

        {/* LEFT SIDE LINKS */}
        <ul className="footer-links footer-left">
          <li><Link to="/admin-login">Admin</Link></li>
          <li><a href="#treatments">Treatments</a></li>
          <li><a href="#team">Our Team</a></li>
          <li><a href="#stories">Patient Stories</a></li>

          {/* SOCIAL ICONS */}
          <li className="footer-social">
            <span>Follow us</span>

            <div className="social-row">
              {/* <a href="#" className="icon-circle"><i className="fab fa-linkedin-in"></i></a>
              <a href="#" className="icon-circle"><i className="fab fa-tiktok"></i></a> */}
              <a href="https://www.instagram.com/primemax_dental_clinic/" className="icon-circle"><i className="fab fa-instagram"></i></a>
              {/* <a href="#" className="icon-circle"><i className="fab fa-youtube"></i></a> */}
            </div>
          </li>
        </ul>

        {/* CENTER LOGO - SWITCHES AUTOMATICALLY */}
        <div className="footer-logo">
          {/* <img src={footerLogo} alt="Dentoshine Logo" /> */}
          <header className="logo-head">PrimeMax</header>
        </div>

        {/* RIGHT SIDE LINKS */}
        <ul className="footer-links footer-right">
          <li><a href="#faq">FAQ</a></li>
          <li><a href="#store">Store Locator</a></li>
          {/* <li><a href="#blog">Blog</a></li> */}
          <li><a href="#privacy">Privacy Policy</a></li>
          <li><a href="#terms">Terms & Conditions</a></li>
        </ul>
      </div>

      <p className="footer-copy">
        © {new Date().getFullYear()} PrimeMax. All rights reserved.
      </p>
    </footer>
  );
}
